export default __webpack_public_path__ + "static/media/sigma-logo-transparent.a7b7c495.png";